import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LoaderService } from '@service/loader.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-loader',
  imports: [
    ProgressSpinnerModule,
    CommonModule,
  ],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {
  get loading(): Observable<boolean> {
    return this.loaderService.loading;
  }

  constructor(
    private loaderService: LoaderService,
  ) { }
}
